import sanityClient from "../client";

const PRESS_QUERY = `*[_type == "pressArticle"] | order(date desc) {
  _id,
  title,
  publication,
  date,
  approximateDate,
  excerpt,
  author,
  photographer,
  externalUrl,
  featured,
  body,
  "scans": scans[]{
    caption,
    "url": asset->url,
    "alt": asset->altText,
    "width": asset->metadata.dimensions.width,
    "height": asset->metadata.dimensions.height
  }
}`;

/** All press items, newest first. Returns [] rather than throwing. */
export async function fetchPress() {
  try {
    return (await sanityClient.fetch(PRESS_QUERY)) || [];
  } catch (err) {
    console.error("Error fetching pressArticle:", err);
    return [];
  }
}

/**
 * Editors can flag an item as year-only when the exact publication day is
 * unknown, so an undated archive clipping reads "2014" instead of a
 * misleadingly precise "January 1, 2014".
 */
export function formatPressDate(date, approximate) {
  if (!date) return "";
  // Parse as UTC: a bare "2014-01-01" would otherwise shift a day backwards
  // in negative-offset timezones and render as 2013.
  const d = new Date(`${date}T00:00:00Z`);
  if (Number.isNaN(d.getTime())) return "";
  if (approximate) return String(d.getUTCFullYear());
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

/** Sanity CDN transform — keeps full-page scans from shipping at full size. */
export function scanUrl(url, width) {
  if (!url) return url;
  return `${url}?w=${width}&auto=format&fit=max`;
}
